
































































import i18n from 'vue-i18n';
import axios from 'axios';
import { get } from 'lodash';
import CoIcon from '../../../../Atoms/co-icon/CoIcon.vue';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoRoundButton from '../../../../Atoms/co-round-button/CoRoundButton.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoEvent from '@/components/Molecules/co-event/CoEvent.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoScrollMarker from '@/components/Molecules/co-scroll-marker/CoScrollMarker.vue';

export default {
    i18n: {
        messages: {
            en: {
                eventsemptyheadline: 'Community Events',
                eventsempty: 'No events available',
                endofeventlistreached: 'All events loaded',
                seememberevents: 'All member events',
            },
            de: {
                eventsemptyheadline: 'Community-Veranstaltungen',
                eventsempty: 'Keine Veranstaltungen verfügbar',
                endofeventlistreached: 'Alle Veranstaltungen geladen',
                seememberevents: 'Alle Mitgliederveranstaltungen',
            },
        },
    },
    name: 'ListPublicEvents',
    components: {
        CoButton,
        CoIcon,
        CoRoundButton,
        CoCard,
        CoHeadline,
        CoEvent,
        CoThumbnail,
        CoText,
        CoScrollMarker,
    },
    props: {
        variant: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'micro', 'list', 'full'].includes(value),
        },
    },
    data() {
        return {
            feed: [],
            feedNextPage: null,
            loading: true,
            thisSpaceID: this.$store?.state?.space?.ID || '',
        };
    },
    computed: {
        me() {
            return this.$store?.state?.me || {};
        },
        isDesktop() {
            return window.innerWidth >= 768;
        },
        isAdmin() {
            if (this.$store?.state?.me?.Permissions?.includes('space_admin') === true) {
                return true;
            }
            return false;
        },
        isUserAllowedToCreateEvent() {
            return this.$store.state.permissions && this.$store.state.permissions['events.create'] === true;
        },
        isUserLogggedIn() {
            return this.me.ID ? true : false;
        },
    },
    async mounted() {
        this.loading = true;
        await this.getPublicEvents();
        this.loading = false;
    },
    methods: {
        getPublicEvents() {
            return axios
                .get(this.feedNextPage || '/public/event/list')
                .then((response) => {
                    const events = response.data?.Events || null;
                    this.feedNextPage = response.data?.Next || null;
                    if (!events || events.length < 1) {
                        return;
                    }

                    const feedPage = [];
                    events.forEach((e) => {
                        // process the event items data structure
                        const event = e || {};
                        event.OrganizersProfiles = event.Organizers || [];
                        event.ParticipantProfiles = event.Participants || [];
                        feedPage.push({
                            object: {
                                ...event,
                                Images: event.Images?.map((i) => ({ ImageURL: i })) || [],
                            },
                        });
                    });
                    // update the feed list
                    this.feed = (this.feed || []).concat(feedPage);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async loadNextPage({ entry, observer }) {
            if (this.feedNextPage && !this.loading) {
                this.loading = true;
                await this.getPublicEvents();
                this.loading = false;
            }
        },
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
